import React from 'react';
import './education.css';
import SchoolIcon from '@mui/icons-material/SchoolOutlined';
import Reveal from '../Reveal/Reveal';
import { education } from '../../data/profile';

function Education() {
  return (
    <section className="section section--alt" id="education">
      <div className="container">
        <Reveal className="section-head">
          <span className="section-eyebrow">Education</span>
          <h2 className="section-title">Where I studied</h2>
        </Reveal>

        <ul className="education-list">
          {education.map(({ school, qualification, period }, index) => (
            <Reveal
              as="li"
              key={school}
              className="card education-item"
              delay={index * 70}
            >
              <span className="education-icon" aria-hidden="true">
                <SchoolIcon fontSize="small" />
              </span>
              <div className="education-body">
                <h3 className="education-school">{school}</h3>
                <p className="education-qualification">{qualification}</p>
              </div>
              <span className="education-period">{period}</span>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Education;
